import { render, staticRenderFns } from "./ReceiveInventoryList.vue?vue&type=template&id=22f6bf34&scoped=true"
import script from "./ReceiveInventoryList.vue?vue&type=script&lang=js"
export * from "./ReceiveInventoryList.vue?vue&type=script&lang=js"
import style0 from "./ReceiveInventoryList.vue?vue&type=style&index=0&id=22f6bf34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f6bf34",
  null
  
)

export default component.exports